import { softValidateResponse } from "@/server/validation";
import { instance } from "../api-instance";
import { GetAllLoadersResponseSchema } from "./schemas";

export const LoaderApi = {
  getAllLoaders() {
    return instance.post("Loader/GetAllList").then((res) => res.data);
  },
};
